import { render, staticRenderFns } from "./insureImport.vue?vue&type=template&id=213bef72&scoped=true"
import script from "./insureImport.vue?vue&type=script&lang=js"
export * from "./insureImport.vue?vue&type=script&lang=js"
import style0 from "./insureImport.vue?vue&type=style&index=0&id=213bef72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213bef72",
  null
  
)

export default component.exports